const $ = require('jquery');

require('../components/consoleSignature/consoleSignature');
require('../components/dropdown/dropdown');

$(document).ready(function(e) {
    require('./../components/cookieBar/cookieBar');
    require('./../components/spreadLink/spreadLink');

    require('./modules/listForm');
    require('./modules/downloadFullPDF');
    require('./modules/generatePDF');
    require('./modules/previewPDF');
});
